// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"332328cd","629":"3249b458","840":"392999dd"}[chunkId] + ".chunk.js";
};